/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { ButtonProps } from 'reactstrap';
import { useAppSelector } from '../../reducers';
import { isUserManager } from '../../selectors/user';
import IconButton from './IconButton';

interface EditButtonInterface extends ButtonProps{
  onClick?: (e: React.MouseEvent<any, MouseEvent>) => void,
  tooltip?: string;
  className?: string;
};

const EditButton = (props: EditButtonInterface) => {
  const { onClick, tooltip, className = '', outline = true, color = 'secondary' } = props;

  const isManager = useAppSelector(isUserManager);
  if (!isManager) {
    return <></>;
  }

  return <IconButton
    {...props}
    outline={outline}
    color={color}
    className={className}
    tooltip={onClick ? tooltip : 'Coming Soon'}
    icon={'fal fa-cog'} />;
};

export default EditButton;
